import { ICarouselSliderState } from '../states/presentationStates';
import { IStaticState } from '../states/staticStates';

export interface IAsyncState {
    initialData: any;
    docHeaderJsonData: any;
    RequestSend: boolean;
    ifRequireDataGet: number;
    docFooterJsonData: any;
    docBodyJsonData: any;
    presentationHTMLData: any;
    presentationJSONData: any;
    prevEventInstanceId: string;
    pageNumber: string;
    flipVersionData: any;
    originFlipVersionData: any;
    originDocId: any;
    sectionData: any;
    copyURLData: any;
    copyFigureURLData: any;
    cvMenuJsonData: any;
    isCVMenuGot: boolean;
    campaignsSource: {};
    eventsSource: {};
    stacksTrendingData: {};
    stacksRelatedResearchData: {};
    stacksRecData: {};
    stacksPopData: {};
    moreStacksData: {};
    reportingCalendarData: {};
    styleFactorsData: any;
    multiStyleFactorCompanies: Array<any>;
    crmUserDetailsData: any;
    catalystWatchData: any;
    mailResponse: any;
    FPfigureGalleryData: any;
    figureGalleryData: any;
    forecastData: any;
    finSumData: any;
    focusListData: any;
    relatedPublicationsData: any;
    priceChartData: any;
    reportsToRevisit: any;
    cvMacroToolsData: any;
    themesData: any;
    esgData: any;
    analystInfoDataById: any;
    analystInfoDataByName: any;
    pollResultsData: any;
    relatedReportSectionData: any;
    urlData: any;
    flagshipPeriodicals: any;
    sessionContext: any;
    platformIdData: any,
    excludeCopyFigurePlatformIdData: any;
    clickThruJsonData: any;
    globalMarketData: any;
    economicCalendarData: any;
    eventCalendarData: any;
    keyDataChangeData: any;
    mustReadSectionData: any;
    restrictionDetailsData: any;
    bookMeetingEntitlement: IBookMeetingEntitlement;
    companyCoverageByTicker: any;
    companyCoverageByCode: any;
    analystModelData: any;
    fileUrl: string;
    sendEmailData: any;
    userEntitlements: any;
    expectedPerformance: any;
    analystModelLoader: boolean;
    sendEmailError: any;    
    analystSubscriptionData: any;
    subscribeAuthorBySoeidResponse: any;
    campaignsData: any;
}

export interface IBookMeetingEntitlement {
    newBookMeetingEntitled: boolean;
    newBookMeetingReadonly: boolean;
}

export const INITIAL_ASYNC_STATE: IAsyncState = {
    initialData: {},
    docHeaderJsonData: {},
    RequestSend: false,
    ifRequireDataGet: 0,
    docFooterJsonData: {},
    docBodyJsonData: [],
    presentationHTMLData: [],
    presentationJSONData: {},
    prevEventInstanceId: '',
    pageNumber: '1',
    flipVersionData: {},
    originFlipVersionData: {},
    originDocId: '',
    sectionData: {},
    copyURLData: {},
    copyFigureURLData: {},
    cvMenuJsonData: {},
    isCVMenuGot: false,
    campaignsSource: {},
    eventsSource: {},
    stacksTrendingData:  { data: {}, isDataGot: false },
    stacksRelatedResearchData: {data: {}, isDataGot: false},
    stacksRecData: { data: {}, isDataGot: false },
    stacksPopData: { data: {}, isDataGot: false },
    moreStacksData: { data: {}, isDataGot: false },
    styleFactorsData: {},
    multiStyleFactorCompanies: [],
    reportingCalendarData: {},
    crmUserDetailsData: {},
    catalystWatchData: {},
    mailResponse: null,
    FPfigureGalleryData: {},
    figureGalleryData: {},
    forecastData: {
        FOREIGN_EXCHANGE_FORECAST: { data: {}, isDataGot: false },
        COMMODITIES_LIST: { data: {}, isDataGot: false },
        ECONOMICLIST: { data: {}, isDataGot: false },
    },
    finSumData: {},
    focusListData: {},
    relatedPublicationsData: {},
    priceChartData: {},
    reportsToRevisit: {},
    cvMacroToolsData: {},
    themesData: {},
    esgData: {},
    analystInfoDataById: {},
    analystInfoDataByName: {},
    pollResultsData: {},
    relatedReportSectionData: {},
    urlData: {},
    flagshipPeriodicals: {},
    sessionContext: {},
    platformIdData: "",
    excludeCopyFigurePlatformIdData: {},
    clickThruJsonData: {},
    globalMarketData: {},
    economicCalendarData: {},
    eventCalendarData: {},
    keyDataChangeData: {},
    mustReadSectionData: {},
    restrictionDetailsData: {},
    bookMeetingEntitlement:{newBookMeetingEntitled:false,newBookMeetingReadonly:false},
    companyCoverageByTicker: {},
    companyCoverageByCode: {},
    analystModelData: "",
    fileUrl: "",
    sendEmailData: {},
    userEntitlements: "",
    expectedPerformance: {},
    analystModelLoader: true,
    sendEmailError: {},
    analystSubscriptionData: {},
    subscribeAuthorBySoeidResponse: {},
    campaignsData: {},
};

export interface ICommonState {
    menuCode: any;
    screenType: any;
    imageSizeCategory: any;
    multiCompanyMetaData: any;
    switchPageData: ISwitchPageDataDetail;
    collapsed: boolean;
    menuPaneStatus: string;
    currentAuthorID: string;
    currentAuthorName: string;
    updateHealthWarningWidth: number;
    frontpageloaded: boolean;
    updateFinancialsContentTabTitle: number;
    fetchBodyJsonFinished: boolean;
    companyCoverageAndDerivedFields: any;
    offTheCuffTitle: string;
    htmlPDFtoggleStatus: boolean;
}

export interface ISwitchPageDataDetail {
    pageName: string;
    filterName: string;
    filterValue: string;
    authorSoeId: string;
}

export const INITIAL_COMMON_STATE: ICommonState = {
    menuCode: '',
    screenType: 'largeScreen',
    imageSizeCategory: 'default',
    multiCompanyMetaData: null,
    switchPageData: {
        pageName: 'mainPage',
        filterName: '',
        filterValue: '',
        authorSoeId: '',
    },
    collapsed: false,
    menuPaneStatus: '',
    currentAuthorID: '',
    currentAuthorName: '',
    updateHealthWarningWidth: 0,
    frontpageloaded: false,
    updateFinancialsContentTabTitle: 0,
    fetchBodyJsonFinished: false,
    companyCoverageAndDerivedFields: null,
    offTheCuffTitle: '',
    htmlPDFtoggleStatus: true
};

export interface IOffCuffListState {
    openDocIds: Array<string>;
    expandAll: boolean;
    currentTabMode:OffCuffTabType;
    offcuffDataMap: {
      [OffCuffTabType.ByAuthor]: IOffCuffPublicationLibraryData | null;
      [OffCuffTabType.ByAllAuthors]: IOffCuffPublicationLibraryData | null;
    };
    loading: boolean;
    byAuthorData?: IByAuthorData;
    byAllAuthors?: IByAllAuthors;
    offCuffCopyURLData?: Array<IOffCuffCopyURLData>;
}

export interface IByAllAuthors {
    allAuthorsName: Array<IAuthorTopic>;
    status: string;
}
export interface IAuthorTopic {
   analystName:{
        ja?: string,
        en?: string
   };
   analystSoeId: string;
   totalPosts: number;
   sector?: string;
   postUrl: string;
}
export interface IByAuthorData {
    status: string;
    otherTopics: Array<ITopic>;
}
export interface ITopic {
    topicName: string;
    totalPosts: number;
    postUrl: string;
}

export interface IOffCuffCopyURLData {
    docId: string;
    data: string;
}
export interface IOffCuffPublicationLibraryData {
    count: number;
    total: number;
    publications: Array<IOffCuffPublication>;
}
export interface IOffCuffPublication {
    distHeadline: string;
    htmlSynopsis: string; // the first 40 words of the document’s first paragraph
    pageCount: number;
    pubHeadline: string;
    pubTitle: string;
    pubId: string;
    pubKey: string;
    renditionCopyUrl: string;
    renditionUrl: string;
    publishDate: string;
    pubSynopsis: string;
    productType: string;
    productId: string;
    sectors: Array<{id: string; name: {ja: string; en: string;}}>;
    subjects: Array<{id: string; name: string;}>;
    regions: Array<{id: string; name: string;}>;
    authors: Array<{analystId: string; isDefault: string; name:{ja?: string, en?: string;}}>;
    primaryAuthor: { analystId: string; name: string, soeid: string; isDefault: string; };
}
export const enum OffCuffTabType {
    ByAuthor = 'By Author',
    ByAllAuthors = 'By All Authors',
}

export const INITIAL_OFFCUFFLIST_STATE: IOffCuffListState = {
    openDocIds: [],
    expandAll: false,
    offcuffDataMap: {
      [OffCuffTabType.ByAuthor]: null,
      [OffCuffTabType.ByAllAuthors]: null,
    },
    currentTabMode:
        (window.HTML_RENDITION.initialData.urlParameters?.openAllAuthorTab === "true" ||
         window.HTML_RENDITION.initialData.html_light_rendition ||
         window.HTML_RENDITION.initialData.openAllAuthorTab == "true"
        ) ? OffCuffTabType.ByAllAuthors : OffCuffTabType.ByAuthor,
    loading: false,
    offCuffCopyURLData: []
};
export interface IReducerState {
    asyncStateReducer: IAsyncState;
    presentationStateReducer: ICarouselSliderState;
    commonStateReducer: ICommonState;
    staticStateReducer: IStaticState;
    offCuffListStateReducer: IOffCuffListState;
}

export type SubscribeResult = {
    message: string;
    status: string;
    id?: string;
}
